import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const quizCheckboxGroupViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map